<template>
	<SimpleModalComponent
		heading="Asset Status"
		@close-modal="emit( 'close-modal' )"
	>
		<template #content>
			<fieldset class="form__radiogroup mb-24">
				<legend class="invisible">
					Asset Status
				</legend>
				<label
					for="live"
					class="form__radio"
				>
					<input
						id="live"
						v-model="status"
						type="radio"
						name="asset-status"
						value="live"
					>
					Live
				</label>
				<label
					for="paused"
					class="form__radio"
				>
					<input
						id="paused"
						v-model="status"
						type="radio"
						name="asset-status"
						value="paused"
					>
					Paused
				</label>
				<label
					for="completed"
					class="form__radio"
				>
					<input
						id="cancelled"
						v-model="status"
						type="radio"
						name="asset-status"
						value="cancelled"
					>
					Cancelled
				</label>
			</fieldset>

			<p
				v-if="error_message"
				class="error-message"
			>
				{{ error_message }}
			</p>
		</template>

		<template #buttons>
			<button
				class="button"
				:disabled="loading"
				@click="closeModal"
			>
				Cancel
			</button>
			<button
				class="button button--fill"
				:class="{ 'button--loading' : loading }"
				:disabled="loading"
				@click="updateAssetStatus"
			>
				Save
			</button>
		</template>
	</SimpleModalComponent>
</template>

<script setup>
import SimpleModalComponent from './SimpleModalComponent.vue';

import { ref, onMounted, defineEmits, defineProps } from 'vue';
import { useDataStore } from '../../stores/data';

const emit = defineEmits( ['status-updated', 'close-modal'] );

const props = defineProps( {
	asset: { required: true, type: Object }
} );

const { setAssetStatus } = useDataStore();

const loading = ref( false );
const status = ref( 'live' );
const error_message = ref( null );

onMounted( () => {
	status.value = props.asset.asset_status;
} );

const updateAssetStatus = async() => { // eslint-disable-line snakecasejs/snakecasejs
	error_message.value = null;
	loading.value = true;

	if ( !status.value ) {
		error_message.value = 'Please select an option';
		loading.value = false;
		return;
	}

	try {
		const response = await setAssetStatus( {
			asset_id: props.asset.id,
			asset_status: status.value
		} );
		if ( response && response.data ) {
			emit( 'status-updated' );
		}
	} catch ( error ) {
		error_message.value = error;
		loading.value = false;
	}
};
</script>